module.exports = __webpack_public_path__ + "static/2-97d56fef8642b38b4e00b257a39cb653.jpg";